import { render, staticRenderFns } from "./detailsTab2.vue?vue&type=template&id=2fd2e700&scoped=true"
import script from "./detailsTab2.vue?vue&type=script&lang=js"
export * from "./detailsTab2.vue?vue&type=script&lang=js"
import style0 from "./detailsTab2.vue?vue&type=style&index=0&id=2fd2e700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd2e700",
  null
  
)

export default component.exports